import type { SectionCategoryEntry } from '@heidi/integrations/ehr/contracts';

export const DURIA_PVS_SYSTEM_NAMES = ['Duria', 'Duria2'] as const;

// Abakus (Duria's integrator) confirmed 7001/7002/7003 as their standard
// custom field-id mapping for Anamnese/Befund/Therapie -- outside the GDT
// 2.1 open-category range (6330-6398) other PVS configs use, but valid for
// Duria's direct field-id routing. Procedere has no confirmed code from
// Abakus; 7004 extrapolates the same pattern. All rows stay user-editable
// in Heidi's settings.
export const DURIA_GDT_SECTION_MAPPINGS: SectionCategoryEntry[] = [
  { fieldId: '7001', sectionName: 'Anamnese', categoryCode: 'AN' },
  { fieldId: '7002', sectionName: 'Befund', categoryCode: 'BE' },
  { fieldId: '7003', sectionName: 'Therapie', categoryCode: 'TH' },
  { fieldId: '7004', sectionName: 'Procedere', categoryCode: 'PR' },
];

function normalisePvsName(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, '');
}

export function isDuriaPvsSystemName(name?: string | null): boolean {
  if (!name) return false;
  const normalised = normalisePvsName(name);
  return normalised === 'duria' || normalised === 'duria2';
}

export function getDuriaDefaultGdtSectionMappings(): SectionCategoryEntry[] {
  return DURIA_GDT_SECTION_MAPPINGS.map((entry) => ({ ...entry }));
}
